import { useQuery, useQueryClient } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getCompanySettings = async (companyId) => {
    const { data } = await vlqrApi.get(`Companies/${companyId}/Settings`)
        .catch((error) => {
            handleError(error);
            throw error;
        });
    return data;
};

const useCompanySettings = (companyId) => {
    const queryClient = useQueryClient();
    const { data, isLoading, isError } = useQuery({
        queryKey: ['companySettings', companyId],
        queryFn: () => getCompanySettings(companyId),
        enabled: !!companyId,
        staleTime: Infinity
    });

    const updateSettings = async (settings) => {
        await vlqrApi.patch(`Companies/${companyId}/Settings`, settings)
            .catch((error) => {
                handleError(error);
                throw error;
            });
        queryClient.invalidateQueries({ queryKey: ['companySettings', companyId] });
    };

    return { settings: data, isLoading, isError, updateSettings };
};

export default useCompanySettings;
